
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  props: {
    active: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false
    },
    userName: {
      type: String as PropType<string>,
      required: false,
      default: ''
    }
  }
})
